import React, {Component} from "react";
import About from "./AboutView";
import {CommonService} from "../../service/commons/CommonService";
import {CUSTODIA_GARANTIA_SERVICE_CONTEXT} from "../../utils/constants/ContextConstants";

export default class AboutContainer extends Component {
    constructor(props) {
        super(props);
        this.commonService = new CommonService();

        this.getHealthTrustService = this.getHealthTrustService.bind(this);

        this.state = {
            aboutPanel: [],
        }

        this.getHealthTrustService();
    }

    getHealthTrustService() {
        this.commonService.getMicroserviceHealth(CUSTODIA_GARANTIA_SERVICE_CONTEXT).then(
            response => {
                let aboutPanel = this.state.aboutPanel;
                aboutPanel.push({id: "Fiduciario", value: response.status === 200 ? response.status : "DOWN"},)
                this.setState({
                    aboutPanel: aboutPanel,
                })
            });
    }

    render() {
        return <About
            aboutPanel={this.state.aboutPanel}
        />
    }
};